import { Model } from "./Model";
import { apiPost } from "@/session";
export class EventNotes extends Model {
    static fromJson(json) {
        return new EventNotes(parseInt(json.eid, 10), parseInt(json.enid, 10), parseInt(json.author, 10), json.message, json.created);
    }
    constructor(eid, enid, author, message, created) {
        super(created);
        this.data.eid = eid;
        this.data.enid = enid;
        this.data.author = author;
        this.data.message = message;
    }
    insert() {
        return apiPost("/events/" + this.eid + "/notes", {
            message: this.message,
        }).then((status) => {
            if (status.status === 201) {
                return status.data.insertId;
            }
            throw new Error(JSON.stringify(status.data));
        });
    }
    get eid() {
        return this.data.eid;
    }
    get enid() {
        return this.data.enid;
    }
    get author() {
        return this.data.author;
    }
    get message() {
        return this.data.message;
    }
    update() {
        // TODO
        return Promise.reject();
    }
}
//# sourceMappingURL=EventNotes.js.map